export default "__VITE_ASSET__H8$YKCwj__"